import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  OrganizationalFunction,
  OrganizationalFunctionCreateRequest,
  OrganizationalFunctionCreateResponse,
  OrganizationalFunctionDetails,
  OrganizationalFunctionUpdateRequest,
  OrganizationalFunctionUpdateResponse,
} from '@ms-organization-entities';
import { ApiClientConfig } from '../api-client-config';
import { PriorityPatchRequest } from '@primatoo-ms-organization';
import { DataProtectionGovernanceService } from '../interface/data-protection-governance-service';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root',
})
export class OrganizationalFunctionService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/organizational-functions/';
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  setPriority(
    id: number,
    request: PriorityPatchRequest
  ): Observable<OrganizationalFunction> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<OrganizationalFunction>(url, request);
  }

  public getOrganizationalFunctions(): Observable<OrganizationalFunction[]> {
    // let url = this.endpoint;
    // if (selectedLegalEntities?.length > 0) {
    //   url += `?q=${ApiClientUtils.buildLegalEntitiesFilter(selectedLegalEntities)}`;
    // }
    return this.httpClient.get<OrganizationalFunction[]>(this.endpoint);
  }

  public getOrganizationalFunctionsById(
    id: number
  ): Observable<OrganizationalFunction> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<OrganizationalFunction>(url);
  }

  public deleteOrganizationalFunction(id: number): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<void>(url);
  }

  public createOrganizationalFunction(
    requestBody: OrganizationalFunctionCreateRequest
  ): Observable<OrganizationalFunctionCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<OrganizationalFunctionCreateResponse>(
      url,
      requestBody
    );
  }

  public updateOrganizationalFunction(
    id: number,
    requestBody: OrganizationalFunctionUpdateRequest
  ): Observable<OrganizationalFunctionUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<OrganizationalFunctionUpdateResponse>(
      url,
      requestBody
    );
  }

  public getOrganizationalFunctionDetails(
    id: number
  ): Observable<OrganizationalFunctionDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<OrganizationalFunctionDetails>(url);
  }

  exportRaw() {
    const url = this.endpoint + `download`;
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
